import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getDefaultZIndex } from "./auth-service-tools182.js";
import { getSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { factory } from "./auth-service-tools248.js";
import { useDirection } from "./auth-service-tools250.js";
import { ModalBase } from "./auth-service-tools284.js";
import { DrawerProvider } from "./auth-service-tools365.js";
import classes from "./auth-service-tools364.js";

function getDrawerAlign(position) {
  switch (position) {
    case "top":
      return "flex-start";

    case "bottom":
      return "flex-end";

    default:
      return void 0;
  }
}

function getDrawerFlex(position) {
  if (position === "top" || position === "bottom") {
    return "0 0 calc(100% - var(--drawer-offset, 0rem) * 2)";
  }

  return void 0;
}

const transitions = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
};
const rtlTransitions = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
};
const defaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  position: "left"
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    position,
    size,
    offset
  } = _ref;
  return {
    root: {
      "--drawer-size": getSize(size, "drawer-size"),
      "--drawer-flex": getDrawerFlex(position),
      "--drawer-height": position === "left" || position === "right" ? void 0 : "var(--drawer-size)",
      "--drawer-align": getDrawerAlign(position),
      "--drawer-justify": position === "right" ? "flex-end" : void 0,
      "--drawer-offset": rem(offset)
    }
  };
});
const DrawerRoot = factory((_props, ref) => {
  const props = useProps("DrawerRoot", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    scrollAreaComponent,
    position,
    transitionProps,
    radius,
    ...others
  } = props;
  const {
    dir
  } = useDirection();
  const getStyles = useStyles({
    name: "Drawer",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const drawerTransition = (dir === "rtl" ? rtlTransitions : transitions)[position];
  return /* @__PURE__ */jsxRuntimeExports.jsx(DrawerProvider, {
    value: {
      scrollAreaComponent,
      getStyles,
      radius
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(ModalBase, {
      ref,
      ...getStyles("root"),
      transitionProps: {
        transition: drawerTransition,
        ...transitionProps
      },
      unstyled,
      ...others
    })
  });
});
DrawerRoot.classes = classes;
DrawerRoot.displayName = "@mantine/core/DrawerRoot";
export { DrawerRoot };